import { Button, Input, message } from 'antd';
import React, { useState } from 'react';
import './LoginFlag.css';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { MailOutlined, LockOutlined, CloseOutlined } from '@ant-design/icons';
import axiosInstance from '../../Config/axiosConfig';

function LoginFlag({ email, deviceId, userIp, userId, setLoggedIn, onVerificationSuccess, onClose }) {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();

  const handleResendOTP = async () => {
    setResendLoading(true);
    try {
      await axiosInstance.post("/User/resend-otp",
        { username: email, userId },
        {
          headers: {
            UserDevice: deviceId,
            UserIPAddress: userIp
          },
        }
      );
      message.success("New OTP sent to your email!");
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to resend OTP");
    } finally {
      setResendLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      message.error("Please enter the OTP");
      return;
    }

    if (otp.length !== 6) {
      message.error("OTP must be 6 digits");
      return;
    }

    setLoading(true);
    try {
      const response = await axiosInstance.post("/User/verify-otp",
        {
          username: email,
          otp: otp,
          userId: userId
        },
        {
          headers: {
            UserDevice: deviceId,
            UserIPAddress: userIp
          },
        }
      );

      if (response.data.code === 200) {
        const token = response.data.data.jwt;
        localStorage.setItem("accessToken", token);
        
        const decodedToken = jwtDecode(token);
        localStorage.setItem("userInfo", JSON.stringify({
          name: decodedToken.name,
          username: decodedToken.username,
          role: decodedToken.role,
          exp: decodedToken.exp,
          userId: decodedToken.userId
        }));

        setLoggedIn(true);
        message.success("OTP verified successfully!");
        
        if (onVerificationSuccess) {
          onVerificationSuccess();
        }

        const userRole = decodedToken.role.toLowerCase();
        switch (userRole) {
          case "admin":
            navigate("/admin-page/dashboard");
            break;
          case "teacher":
            navigate("/teacher-home", {
              state: {
                userId: decodedToken.userId,
                name: decodedToken.name
              }
            });
            break;
          case "student":
            navigate("/");
            break;
          default:
            navigate("/courses");
        }
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to verify OTP");
    } finally {
      setLoading(false);
    }
  };

    const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="login-flag-page-container">
      <div className="login-flag-container">
        <button className="close-button" onClick={handleClose}>
          <CloseOutlined />
        </button>
        <div className="login-flag-icon">
          <LockOutlined />
        </div>
        
        <h2>Security Verification</h2>
        <p>We've sent a 6-digit verification code to your email</p>
        
        <div className="verification-info">
          <p>Verifying: <strong>{email}</strong></p>
        </div>
        
        <div className="input-container">
          <Input 
            prefix={<LockOutlined />}
            placeholder="Enter 6-digit OTP" 
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
            maxLength={6}
            type="text"
            inputMode="numeric"
          />
        </div>
        
        <Button 
          type="primary"
          onClick={handleVerifyOTP}
          loading={loading}
          disabled={otp.length !== 6}
          className="verify-button"
        >
          {loading ? "Verifying..." : "Verify & Continue"}
        </Button>
        
        <div className="resend-otp">
          Didn't receive the code?{' '}
          <Button type="link" onClick={handleResendOTP} disabled={resendLoading}>
            {resendLoading ? "Sending..." : "Resend OTP"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LoginFlag;